import axios, { type AxiosRequestConfig } from 'axios';
import type { ApiResponse } from './types/api';
import { BizError, NetworkError } from './errors';
import { getErrorMessage } from './error-codes';

// Axios 实例
const httpClient = axios.create({
  baseURL: '/api',
  withCredentials: true, // HttpOnly Cookie 自动携带
  timeout: 10000,
});

// 类型安全的请求函数：解包 ApiResponse 并返回 data
export async function request<T>(config: AxiosRequestConfig): Promise<T> {
  try {
    const response = await httpClient.request<ApiResponse<T>>(config);
    const body = response.data;
    if (body.code === 0) {
      return body.data;
    }
    // Token 无效：跳转登录页
    if (body.code === 4002) {
      window.location.href = '/login';
    }
    const message = body.message || getErrorMessage(body.code);
    throw new BizError(body.code, message);
  } catch (error) {
    if (error instanceof BizError) {
      throw error;
    }
    throw new NetworkError(error instanceof Error ? error.message : '网络异常');
  }
}
